import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class StateService {
  private _dictionary: Map<StateKey, any> = new Map()

  constructor() {}

  setStateFor = (key: StateKey, val: any) => this._dictionary.set(key, val)
  getStateOf = (key: StateKey) => this._dictionary.get(key)
}

export enum StateKey {
  OrganizationId = 'OrganizationId',
  HotelId = 'HotelId',
}
